import { useLayoutEffect, useEffect, useState, useContext } from 'react';

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

import { assessmentList } from './api';
import { DataContext } from 'contexts/DataContext';

interface AssessmentListProps {
  assessments: any[];
}

const AssessmentScore = (props: AssessmentListProps) => {
    const dataContext = useContext(DataContext);
    const isDark = !!dataContext.darkMode;

    useLayoutEffect(() => {
        let root = am5.Root.new("AssessmentScore");
        root._licenseApplied();

        root.setThemes([
            am5themes_Animated.new(root),
        ]);




      // Create chart
      var chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            layout: root.verticalLayout,
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            paddingLeft:0
          })
        );

        var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
          behavior: "zoomX"
        }));
        cursor.lineY.set("visible", false);

        var scrollbarX = am5.Scrollbar.new(root, {
          orientation: "horizontal"
        });
        // scrollbar styling: dark grey in dark mode, default in light
        const scrollBgColor = am5.color(isDark ? 0x444444 : 0xcccccc);
        const scrollHandleColor = am5.color(isDark ? 0x4F4F4F : 0xe0e0e0);
        scrollbarX.get("background")?.setAll({
          fill: scrollBgColor,
          fillOpacity: 1,
        });
        scrollbarX.startGrip.get("background")?.setAll({
          fill: scrollHandleColor,
          stroke: scrollHandleColor,
        });
        scrollbarX.endGrip.get("background")?.setAll({
          fill: scrollHandleColor,
          stroke: scrollHandleColor,
        });
        scrollbarX.thumb.setAll({
          fill: scrollHandleColor,
          stroke: scrollHandleColor,
        });
        
        chart.set("scrollbarX", scrollbarX);
        chart.bottomAxesContainer.children.push(scrollbarX);

        
        var data = props.assessments.map(item=>{
          return {name:item.name, score:item.score.all, maturity:item.maturity.all};
        })
    
        
        var xRenderer = am5xy.AxisRendererX.new(root, {
          minorGridEnabled: true,
          minGridDistance: 0,
          cellStartLocation: 0.2,
          cellEndLocation: 0.8,
        });
        xRenderer.grid.template.setAll({
          visible: false,
          stroke: am5.color(isDark ? 0x666666 : 0x000000),
        });
        
            // Label settings
            xRenderer.labels.template.setAll({
              rotation: -45,
              centerY: am5.p50,
              centerX: am5.p100,
              paddingRight: 15,
              fontSize: 12,
              fontWeight: "bold",
              fill: am5.color(isDark ? 0xffffff : 0x000000),
            });   
            xRenderer.grid.template.setAll({ visible: false })
            // Create X axis (Category)
            const xAxis = chart.xAxes.push(
              am5xy.CategoryAxis.new(root, {
                categoryField: "name",
                renderer: xRenderer,
                tooltip: am5.Tooltip.new(root, {}),
                startLocation: 0.1,
                endLocation: 0.9
              })
            );
            xAxis.data.setAll(data);
            xAxis.events.once("datavalidated", ev => {
              ev.target.zoomToIndexes(0, 7);
            });
        
            // Create Y axis renderer with horizontal stripes, no grid lines
            const yRenderer = am5xy.AxisRendererY.new(root, {
              cellStartLocation: 0.1,
              cellEndLocation: 0.9,
              strokeOpacity: 1,
              stroke: am5.color(isDark ? 0x666666 : 0x000000),
            });
            // zebra: chiaro in light, bande scure in dark
            yRenderer.axisFills.template.setAll({
              visible: true,
              fill: am5.color(isDark ? 0x222222 : 0x000000),
              fillOpacity: isDark ? 0.5 : 0.05,
            });
            yRenderer.grid.template.setAll({ visible: false });
            yRenderer.labels.template.setAll({
              fontSize: 12,
              fontWeight: "bold",
              fill: am5.color(isDark ? 0xffffff : 0x000000),
            });
        
            // Create Y axis (Value)
            const yAxis = chart.yAxes.push(
              am5xy.ValueAxis.new(root, {
                min: 0,
                extraMax: 0.1,
                renderer: yRenderer
              })
            );
  
        //Score bars
        var series1 = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: "Score",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "score",
            categoryXField: "name",
            marginRight:30,
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "horizontal",
              labelText: "Score: {valueY} {info}"
            })
          })
        );
        
        series1.columns.template.setAll({
          tooltipY: am5.percent(10),
          templateField: "columnSettings",
          marginRight:200
        });
        
        series1.data.setAll(data);
  
        //Score bars
        var series2 = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: "Maturity",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "maturity",
            categoryXField: "name",
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "horizontal",
              labelText: "Maturity: {valueY} {info}"
            })
          })
        );
        
        series2.columns.template.setAll({
          tooltipY: am5.percent(10),
          templateField: "columnSettings"
        });
        
        series2.data.setAll(data);

        series1.columns.template.setAll({
          width: am5.percent(100),
          fill: am5.color(0x2ab5f6),
          stroke: am5.color(0x2ab5f6)
        });
        series2.columns.template.setAll({
          width: am5.percent(100),
          fill: am5.color(0x197caa),
          stroke: am5.color(0x197caa)
        });
        /*
        //Maturity lines
        var series2 = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: "Maturity",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "maturity",
            categoryXField: "name",
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "horizontal",
              labelText: "Maturity: {valueY} {info}"
            })
          })
        );
        
        series2.strokes.template.setAll({
          strokeWidth: 2,
          templateField: "strokeSettings"
        });
        
        series2.data.setAll(data);
        
        series2.bullets.push(function () {
          return am5.Bullet.new(root, {
            sprite: am5.Circle.new(root, {
              strokeWidth: 3,
              stroke: series2.get("stroke"),
              radius: 5,
              fill: root.interfaceColors.get("background")
            })
          });
        });
          */

        /**
         * Exporting
         */
        /*var exporting = am5plugins_exporting.Exporting.new(root, {
          menu: am5plugins_exporting.ExportingMenu.new(root, {}),
          backgroundColor: am5.color("#fff"),
          backgroundOpacity: 1,
          filePrefix: "PostureByAssessment",
        });
        
        exporting.events.on("exportstarted", function() {
          root.setThemes([]);
          scrollbarX.set("visible", false);
        });

        exporting.events.on("exportfinished", function() {
          root.setThemes([
              am5themes_Animated.new(root),
              am5themes_Dark.new(root)
          ]);
          scrollbarX.set("visible", true);
        });
        */

        chart.appear(1000, 100);
        series1.appear();
        series2.appear();

        return () => {
          root.dispose();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [props.assessments, isDark]);
    
      return (
        <div id="AssessmentScore" style={{ width: "100%", height: "473px" }}></div>
      );
}

export default AssessmentScore;